import React from "react";
import ReactDom from "react-dom";
import { Provider } from "react-redux";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { PersistGate } from "redux-persist/integration/react";

import App from "src/App";
import { persistor, store } from "src/store";

import AbilityProvider from "_utils/ability";
import QueryClientProvider from "_utils/react-query";

import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "_configs/polyfill";
import "core-js";
import "_configs";
import "_configs/axios";
import "_configs/ability";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log(
          "Service Worker registered with scope:",
          registration.scope
        );
      })
      .catch((err) => {
        console.error("Service Worker registration failed:", err);
      });
  });
}

dayjs.extend(relativeTime);

const Render = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AbilityProvider>
          <QueryClientProvider>
            <App />
          </QueryClientProvider>
        </AbilityProvider>
      </PersistGate>
    </Provider>
  );
};

ReactDom.render(<Render />, document.getElementById("root"));
